import styled from 'styled-components';

const FooterWrapper = styled.footer`
  position: relative;
  background: #0b1a2e;
  color: #fff;
  padding-top: 24px;
  overflow: hidden;

  .footer_container {
    background-repeat: no-repeat;
    background-position: center 50px;
    padding-top: 64px;
    padding-bottom: 48px;
    position: relative;
    @media (max-width: 990px) {
      padding-bottom: 32px;
    }
    @media (max-width: 767px) {
      padding-top: 48px;
      padding-bottom: 8px;
    }
  }
`;

const List = styled.ul``;

const ListItem = styled.li`
  a,
  button {
    color: #dbe5f5;
    font-size: 14px;
    line-height: 36px;
    padding: 0;
    border: 0;
    background: none;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover,
    &:focus {
      outline: 0;
      text-decoration: none;
      color: #fff;
      text-decoration: underline;
    }
  }
`;

export { List, ListItem };

export default FooterWrapper;
